import { useState } from "react";
import { pathOf } from "./skillsCatalog";
import type { BrowserTab } from "./SkillsSkillDetail";

export type FinderChoice = { budget: number; action: "create" | "catalogue"; reanalyse: boolean };

/** Maquette D: where to look and what to do next, without describing anything. */
export default function SkillsFinder({ tab, origin, model, canAct, initialBudget = 1, onStart, onClose }: {
  tab?: BrowserTab; origin: string; model?: string; canAct: boolean; initialBudget?: number;
  onStart: (choice: FinderChoice) => void; onClose: () => void;
}) {
  const [site, setSite] = useState(initialBudget > 1);
  const [budget, setBudget] = useState(initialBudget > 1 ? initialBudget : 5);
  const [action, setAction] = useState<"create" | "catalogue">("create");
  const [reanalyse, setReanalyse] = useState(false);
  return <div className="skills-sheet" role="dialog" aria-label="Trouver des skills" onKeyDown={e => { if (e.key === "Escape") onClose(); }}>
    <header><strong>Trouver des skills</strong><button aria-label="Fermer" onClick={onClose}>✕</button></header>
    <p className="skills-muted">Onglet : {tab ? tab.title || pathOf(tab.url) : "aucun onglet ouvert sur " + origin} · onglet actuel</p>
    <fieldset><legend>Jusqu’où ?</legend>
      <label><input type="radio" name="skills-finder-scope" checked={!site} onChange={() => setSite(false)} />Cette page et ses menus</label>
      <label><input type="radio" name="skills-finder-scope" checked={site} onChange={() => setSite(true)} />Aussi d’autres pages du site
        <select aria-label="Nombre de pages au plus" value={budget} disabled={!site} onChange={e => setBudget(Number(e.target.value))}>{Array.from({ length: 9 }, (_, i) => <option key={i + 2} value={i + 2}>{i + 2}</option>)}</select> pages au plus</label>
    </fieldset>
    <fieldset><legend>Ensuite ?</legend>
      <label><input type="radio" name="skills-finder-next" checked={action === "create"} onChange={() => setAction("create")} />Créer et tester tout de suite ce qui ne fait que lire</label>
      <label><input type="radio" name="skills-finder-next" checked={action === "catalogue"} onChange={() => setAction("catalogue")} />Me montrer les idées d’abord</label>
    </fieldset>
    <p>Rien n’est modifié sur le site sans ton accord.</p>
    <details><summary>Options avancées</summary>
      <label><input type="checkbox" checked={reanalyse} onChange={e => setReanalyse(e.target.checked)} />Réétudier les pages déjà connues</label>
      <p className="skills-muted">Modèle IA : {model ?? "configuré par le serveur"}</p>
    </details>
    <div className="skills-actions"><button className="skills-primary" disabled={!canAct} onClick={() => onStart({ budget: site ? budget : 1, action, reanalyse: !site || reanalyse })}>Lancer l’analyse</button></div>
  </div>;
}
